import { WhiteButton } from "../../../components/UI/Button/button";
import cancelSubCaution from "../../../assets/svgs/cancelSubCaution.svg";
import classes from "./subscriptionPayment.module.css";


const CancelModal = ({ onClose, onConfirm }) => (
  <div className={classes.modalOverlay}>
    <div className={classes.cancelModal}>
      <img src={cancelSubCaution} alt="Cancel warning" className={classes.cancelIcon} />
      <h3>Cancel subscription?</h3>
      <br />
      <p>Are you sure you want to cancel subscription</p>
      <div className={classes.modalButtons}>
        <WhiteButton onClick={onClose}>
          No, continue
        </WhiteButton>
        <button
          className={classes.redButton}
          onClick={onConfirm}
        >
          Yes, cancel
        </button>
      </div>
    </div>
  </div>
);

const SuccessModal = ({ onClose }) => (
  <div className={classes.modalOverlay}>
    <div className={classes.successModal}>
      <button
        className={classes.closeButton}
        onClick={onClose}
      >
        x
      </button>
      <h3>Your payment is confirmed</h3>
      <p className={classes.thanksText}>Thanks for subscribing</p>
      <WhiteButton>
        View invoice
      </WhiteButton>
    </div>
  </div>
);

export { CancelModal, SuccessModal };